._ClientGroupsView_hmmc2_1 {
  /* Empty file & class, used as a placeholder for future styling */
}